import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable, timer } from 'rxjs';

import { IResponseData } from '../nucleo/interface/dto/IResponseData';
import { EnvironmentService } from '../nucleo/configuracion/environment.service';
import { IRequestData } from '../nucleo/interface/dto/IRequestData';
import { IDocumentoDto } from '../nucleo/interface/dto/IDocumentoDto';
import { delayWhen, map, retryWhen, shareReplay, tap } from 'rxjs/operators';

@Injectable()
export class ServicioApiService {
  
  constructor(private http: HttpClient, private configService: EnvironmentService) {

  }

  consultar<FILTRO, ENTIDAD>(path: string, requestData: IRequestData<FILTRO, ENTIDAD>, httpOptions: object): Observable<IResponseData> {
    return this.http.post<IResponseData>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/consultar`,
      requestData, httpOptions);
  }

  descargar(path: string, documentoDto: IDocumentoDto, httpOptions: object): Observable<Blob> {
    return this.http.post<Blob>(
      `${this.configService.webCoreServicio}:${this.configService.webCorePuerto}/${path}/descargar`, 
      documentoDto, httpOptions);
  }
  
}
